import React from 'react';
import { Instagram, Facebook, Youtube, Mail, MapPin, Phone } from 'lucide-react';

const Footer = ({ socialMedia, teamName, logo }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black border-t border-gray-800">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand Section */}
          <div>
            <img loading="lazy" decoding="async" src={logo} alt="Team Logo" className="w-48 h-auto mb-6" />
            <p className="text-gray-400 mb-6 leading-relaxed">
              Around the World
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/teamsevenmotorsport?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                className="w-10 h-10 bg-gray-800 hover:bg-gradient-to-br hover:from-purple-500 hover:to-pink-500 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram className="w-5 h-5 text-white" />
              </a>
              <a
                href="mailto:alessandro.casalini@sevenmotorsport.it,simone.paolucci@sevenmotorsport.it"
                className="w-10 h-10 bg-gray-800 hover:bg-cyan-500 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
              >
                <Mail className="w-5 h-5 text-white" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-xl mb-6">Link Rapidi</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300">
                  Home
                </a>
              </li>
              <li>
                <a href="#riders" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300">
                  I Piloti
                </a>
              </li>
              <li>
                <a href="/gallery" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300">
                  Shooting
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300">
                  Partner
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors duration-300">
                  Contatti
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-xl mb-6">Contatti</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-cyan-400 mt-1 flex-shrink-0" />
                <a
                  href="mailto:simone.paolucci@sevenmotorsport.it"
                  className="text-gray-400 hover:text-cyan-400 transition-colors"
                >
                  simone.paolucci@sevenmotorsport.it
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-cyan-400 mt-1 flex-shrink-0" />
                <a
                  href="mailto:alessandro.casalini@sevenmotorsport.it"
                  className="text-gray-400 hover:text-cyan-400 transition-colors"
                >
                  alessandro.casalini@sevenmotorsport.it
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <Instagram className="w-5 h-5 text-cyan-400 mt-1 flex-shrink-0" />
                <a
                  href="https://www.instagram.com/teamsevenmotorsport?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-cyan-400 transition-colors"
                >
                  @teamsevenmotorsport
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <MapPin className="w-5 h-5 text-cyan-400 mt-1 flex-shrink-0" />
                <span>Italia / Belgium</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © {currentYear} {teamName}. Tutti i diritti riservati.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-500 hover:text-cyan-400 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-500 hover:text-cyan-400 transition-colors">
                Cookie Policy
              </a>
              <a href="#" className="text-gray-500 hover:text-cyan-400 transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
